<template>
  <!-- Thanh chuyển tab đặt chung hàng với nút Bộ lọc của từng tab -->
  <b-nav tabs class="result-tabs">
    <b-nav-item
      v-for="(tab, index) in tabs"
      :key="tab"
      :active="value === index"
      @click="$emit('input', index)"
    >
      {{ tab }}
    </b-nav-item>
  </b-nav>
</template>

<script>
export default {
  name: 'ResultTabs',
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tabs: ['Kết quả học bài', 'Kết quả nhập chỉ số'],
    };
  },
};
</script>

<style lang="scss" scoped>
.result-tabs {
  border-bottom: 0;
}
</style>
